import React from 'react'
import { useTranslation } from 'react-i18next'
import { formattedTime } from 'utils/formatter.js'
import accounting from 'accounting'

import './ProjectStatistic.scss'

const ProjectStatistic = ({ item }) => {
    const { t } = useTranslation()

    return (
        <ul className="project-block__statistic">
            <li className="project-block__statistic-item">
                <div className="project-block__statistic-label">{t('Views')}</div>
                <div className="project-block__statistic-value">
                    {accounting.formatNumber(item.sessionCount, {
                        thousand: ' ',
                    })}
                </div>
            </li>
            <li className="project-block__statistic-item">
                <div className="project-block__statistic-label">{t('Users')}</div>
                <div className="project-block__statistic-value">
                    {accounting.formatNumber(item.uniqueUsersCount, {
                        thousand: ' ',
                    })}
                </div>
            </li>
            <li className="project-block__statistic-item">
                <div className="project-block__statistic-label">{t('Average attention time')}</div>
                <div className="project-block__statistic-value">{formattedTime(item.avgSessionTime)}</div>
            </li>
        </ul>
    )
}

export default ProjectStatistic
